module.exports = __webpack_public_path__ + "static/media/17.9d504399.mp3";